import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { PayPalScriptProvider } from "@paypal/react-paypal-js";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";
import { Toaster } from "./components/ui/sonner";
import CookieConsent from "./components/CookieConsent";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Programs from "./pages/Programs";
import Membership from "./pages/Membership";
import SeatAtTable from "./pages/SeatAtTable";
import LegalDefenseFund from "./pages/LegalDefenseFund";
import PriorityZones from "./pages/PriorityZones";
import Store from "./pages/Store";
import News from "./pages/News";
import FAQ from "./pages/FAQ";
import Contact from "./pages/Contact";
import Legal from "./pages/Legal";
import Auth from "./pages/Auth";
import MemberDashboard from "./pages/MemberDashboard";
import AdminPanel from "./pages/AdminPanel";
import CompliancePanel from "./pages/CompliancePanel";

function ProtectedRoute({ children, adminOnly = false }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center pt-16"><div className="text-navy font-body">Loading...</div></div>;
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/dashboard" replace />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/programs" element={<Programs />} />
      <Route path="/programs/membership" element={<Membership />} />
      <Route path="/programs/seat-at-the-table" element={<SeatAtTable />} />
      <Route path="/programs/legal-defense-fund" element={<LegalDefenseFund />} />
      <Route path="/programs/priority-zones" element={<PriorityZones />} />
      <Route path="/store" element={<Store />} />
      <Route path="/news" element={<News />} />
      <Route path="/faq" element={<FAQ />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/legal/:section?" element={<Legal />} />
      <Route path="/login" element={<Auth />} />
      <Route path="/dashboard" element={<ProtectedRoute><MemberDashboard /></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute adminOnly><AdminPanel /></ProtectedRoute>} />
      <Route path="/admin/compliance" element={<ProtectedRoute adminOnly><CompliancePanel /></ProtectedRoute>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

const paypalOptions = {
  clientId: process.env.REACT_APP_PAYPAL_CLIENT_ID || "sb",
  currency: "USD",
  intent: "capture",
};

function App() {
  return (
    <PayPalScriptProvider options={paypalOptions}>
      <AuthProvider>
        <CartProvider>
          <BrowserRouter>
            <div className="min-h-screen flex flex-col">
              <Navbar />
              <main className="flex-1">
                <AppRoutes />
              </main>
              <Footer />
            </div>
            <Toaster position="top-right" />
            <CookieConsent />
          </BrowserRouter>
        </CartProvider>
      </AuthProvider>
    </PayPalScriptProvider>
  );
}

export default App;
